<h2 mat-dialog-title>Send Consent</h2>
<mat-dialog-content>
  Would you like to send a new <cite><b>{{ data.consentType }}</b></cite> consent?
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton mat-dialog-close cdkFocusInitial>No</button>
  <button matButton [mat-dialog-close]="true">Yes</button>
</mat-dialog-actions>
